import React from "react";
import BackToHome from "./BackToHome";

export function PageHeader({ title, subtitle, testid, crumbs, current, hideBack }) {
  return (
    <div className="mb-8">
      {!hideBack && <BackToHome crumbs={crumbs} current={current} />}
      <div className="float-up" data-testid={testid}>
        <h1 className="font-display text-3xl font-bold tracking-tight text-xmas-snow sm:text-4xl lg:text-5xl">
          {title}
        </h1>
        {subtitle && <p className="mt-3 max-w-2xl text-base text-xmas-slate sm:text-lg">{subtitle}</p>}
        <div className="mt-4 h-px w-24 bg-gradient-to-r from-xmas-gold to-transparent" />
      </div>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle, action, testid }) {
  return (
    <div
      className="glass flex flex-col items-center justify-center rounded-2xl px-6 py-16 text-center"
      data-testid={testid}
    >
      {Icon && (
        <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-xmas-gold/15">
          <Icon className="h-8 w-8 text-xmas-gold" />
        </div>
      )}
      <h3 className="font-display text-xl text-xmas-snow">{title}</h3>
      {subtitle && <p className="mt-2 max-w-md text-sm text-xmas-slate">{subtitle}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export function Loader() {
  return (
    <div className="flex items-center justify-center py-24">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-xmas-gold/30 border-t-xmas-gold" />
    </div>
  );
}
